import React, { Component } from 'react'
import Card from './styled-components/Card'
import LoginOptions from './styled-components/LoginOptions'
import LinkButton from './styled-components/LinkButton'
import DividerText from './styled-components/DividerText'
import HeaderText from './styled-components/HeaderText'
import { GoogleAssistantDisclaimer } from './GoogleAssistantDisclaimer'
import emailIcon from '../images/icon-email.svg'
import googleIcon from '../images/icon-google.svg'
import facebookIcon from '../images/icon-facebook.svg'
import appleIcon from '../images/icon-apple.svg'
import logInGoogleUser from '../logInGoogleUser'
import logInFacebookUser from '../logInFacebookUser'
import logInAppleUser from '../logInAppleUser'
import { TermsOfServiceAndPrivacyPolicyFull } from './TermsOfServiceAndPrivacyPolicy'
import { EmailProviderButton, GoogleProviderButton, FacebookProviderButton, AppleProviderButton, LogInProviderButtonIcon, LogInProviderButtonIconImage, LogInProviderButtonContent } from './styled-components/LogInProviderButtons'
import { AnovaLogo } from './AnovaLogo'
import redirectToURLForNativeFacebookLogIn from '../redirectToURLForNativeFacebookLogIn'
import { analyticsPage } from '../analytics'
import MarketingEmailOptInUser from "./MarketingEmailOptInUser";

const logInWithGoogle = async () => {
  try {
    await logInGoogleUser()
  } catch (error) {
    console.log(error)
  }
}

const logInWithApple = async () => {
  try {
    await logInAppleUser()
  } catch (error) {
    console.log(error)
  }
}

class LogInSelector extends Component {
  componentDidMount () {
    analyticsPage('ALI Log In - Select Log In Provider')
  }

  logInWithFacebook = async () => {
    if (this.props.nativeLogIn === 'true' && this.props.clientID === 'ANOVA_IOS') {
      redirectToURLForNativeFacebookLogIn(this.props.redirectURL)
    } else {
      try {
        await logInFacebookUser()
      } catch (error) {
        console.log(error)
      }
    }
  }

  render () {
    return (
      <Card>
        <div>
          <AnovaLogo />

          <LoginOptions>
            <HeaderText>
              Log in or sign up
            </HeaderText>

            <GoogleAssistantDisclaimer clientID={this.props.clientID} />
            
            <LinkButton to='/email-log-in'>
              <EmailProviderButton data-email-password-login-button>
                <LogInProviderButtonIcon>
                  <LogInProviderButtonIconImage src={emailIcon} alt="continue with email" />
                </LogInProviderButtonIcon>
                <LogInProviderButtonContent>
                  Continue with Email
                </LogInProviderButtonContent>
              </EmailProviderButton>
            </LinkButton>

            <DividerText>OR</DividerText>

            <GoogleProviderButton
              data-google-login-button
              onClick={logInWithGoogle}
            >
              <LogInProviderButtonIcon>
                <LogInProviderButtonIconImage src={googleIcon} alt="continue with google" />
              </LogInProviderButtonIcon>
              <LogInProviderButtonContent>
                Continue with Google
              </LogInProviderButtonContent>
            </GoogleProviderButton>

            <FacebookProviderButton
              data-facebook-login-button
              onClick={this.logInWithFacebook}
            >
              <LogInProviderButtonIcon>
                <LogInProviderButtonIconImage src={facebookIcon} alt="continue with facebook" />
              </LogInProviderButtonIcon>
              <LogInProviderButtonContent>
                Continue with Facebook
              </LogInProviderButtonContent>
            </FacebookProviderButton>

            <AppleProviderButton
              data-apple-login-button
              onClick={logInWithApple}
            >
              <LogInProviderButtonIcon>
                <LogInProviderButtonIconImage src={appleIcon} alt="continue with apple" />
              </LogInProviderButtonIcon>
              <LogInProviderButtonContent>
                Continue with Apple
              </LogInProviderButtonContent>
            </AppleProviderButton>

          </LoginOptions>

        </div>

        <MarketingEmailOptInUser
            handleMarketingEmailOptInUser={this.props.handleMarketingEmailOptInUser}
            marketingEmailOptInUser={this.props.marketingEmailOptInUser} />

        <TermsOfServiceAndPrivacyPolicyFull />
      </Card >
    )
  }
}

export default LogInSelector
